module.exports = __webpack_public_path__ + "img/img_futa_heartspangle.7b152b8a.png";